import React from 'react'
import { Button, Dialog } from 'react-weui'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import axios from 'axios'
import qrcode from 'qrcode'
import { WKVisible } from '../../components/wk'
import successImg from '../../images/sharecard-slide-select.png'


class SchedulePaySuccessPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isShowFollowDialog: false,
            schedule: {},
            qrImg: '',
            isSubscribe: false,
        }
    }
    componentDidMount () {
        axios.get(`/api/schedule/${this.props.params.id}/info`)
            .then(res => {
                const data = res.data.data
                this.setState({ schedule: data.schedule })
            })
        axios.post(`/api/schedule/${this.props.params.id}/signup_qrcode`)
            .then(res => {
                this.toQrImg(res.data.data.qrcode_content)
            })
        this.fetchSubscribeInfo()
    }
    fetchSubscribeInfo () {
        axios.get('/api/schedule/subscribe/info')
            .then(res => {
                this.setState({ isSubscribe: res.data.data.subscribed })
            })   
    }
    onClickQrOk() {
        this.setState({ isShowFollowDialog: false })
    }
    toQrImg(str) {
        qrcode.toDataURL(str, {
            errorCorrectionLevel: 'M',
            margin: 3,
            type: 'image/png',
        }, (err, url) => {
            if (err) throw err
            this.setState({ qrImg: url })
        })
    }
    onClickReceiveRemind () {
        this.setState({ isShowFollowDialog: true })
    }
    render() {
        return (
            <div className="schedule-pay-success-page wk-page text-center">
                <div className="content">
                    <img src={successImg} className='success-img' />
                    <div className="title">购买成功</div>
                    <div className="intro">
                        <p>你已成功参与</p>
                        <p>{this.state.schedule.name}</p>
                    </div>
                    <WKVisible create={this.state.isSubscribe === false}>
                        <Button onClick={e => this.onClickReceiveRemind()}>接收打卡提醒</Button>
                    </WKVisible>
                    <WKVisible create={this.state.isSubscribe === true}>
                        <Button onClick={e => browserHistory.replace(`/schedule/${this.props.params.id}`)}>立即打卡</Button>
                    </WKVisible>
                </div>


                <Dialog type="ios" title='长按扫码，接收打卡提醒' buttons={[
                    { label: '关闭', onClick: () => this.onClickQrOk() }
                ]} show={this.state.isShowFollowDialog}>
                    <div className="text margin-bottom">
                        坚持打卡，平分奖金
                    </div>
                    <div className="qr-dialog">
                        <img src={this.state.qrImg} />
                    </div>
                </Dialog>
            </div>
        )
    }
}

export default connect(state => ({
    account: state.account
}))(SchedulePaySuccessPage)


// WEBPACK FOOTER //
// ./src/pages/schedule/SchedulePaySuccessPage.js